import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class UserStatsPage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    this.statsData = null;
    this.loadingStats = true;
    this.statsError = false;
    this.loadUser(m.route.param('username'));
  }
  show(user) {
    super.show(user);
    this.loadStats();
  }
  loadStats() {
    if (!this.user) return;
    this.loadingStats = true;
    this.statsError = false;
    m.redraw();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/users/".concat(this.user.id(), "/stats")
    }).then(response => {
      this.statsData = response.data;
      this.loadingStats = false;
      m.redraw();
    }).catch(err => {
      this.loadingStats = false;
      this.statsError = true;
      console.error('Error fetching user stats:', err);
      m.redraw();
    });
  }
  content() {
    if (this.loading || this.loadingStats) {
      return m("div", {
        className: "UserStats-loading"
      }, m(LoadingIndicator, null));
    }
    if (this.statsError || !this.statsData) {
      return m("div", {
        className: "UserStats-emptyBox"
      }, m("div", {
        className: "UserStats-emptyIcon"
      }, m("i", {
        className: "fas fa-chart-pie"
      })), m("h3", null, app.translator.trans('nagusi-user-stats.forum.empty.title')), m("p", null, app.translator.trans('nagusi-user-stats.forum.empty.description')));
    }
    const _this$statsData = this.statsData,
      mb = _this$statsData.match_behavior,
      sparrings = _this$statsData.sparrings,
      hours = _this$statsData.hourly_distribution,
      tb = _this$statsData.time_buckets,
      ratings = _this$statsData.ratings,
      lex = _this$statsData.lexicon_and_emojis,
      karma = _this$statsData.karma,
      jokoak = _this$statsData.jokoak,
      polls = _this$statsData.polls;
    return m("div", {
      className: "UserStats-container"
    }, m("div", {
      className: "UserStats-header"
    }, m("div", {
      className: "UserStats-headerContent"
    }, m("h2", {
      className: "UserStats-title"
    }, m("i", {
      className: "fas fa-chart-line"
    }), " ", app.translator.trans('nagusi-user-stats.forum.title')), m("p", {
      className: "UserStats-subtitle"
    }, app.translator.trans('nagusi-user-stats.forum.subtitle')))), m("div", {
      className: "UserStats-grid"
    }, this.renderMatchBehaviorCard(mb), this.renderSparringsCard(sparrings), this.renderRatingsCard(ratings), this.renderHourlyCard(hours, tb), this.renderLexiconCard(lex), this.renderPollsCard(polls), this.renderKarmaCard(karma), this.renderJokoakCard(jokoak)));
  }
  renderMatchBehaviorCard(mb) {
    if (!mb) return null;
    const totalMatchCycle = mb.match_day_posts + mb.hangover_day_posts + mb.pre_match_posts + mb.other_day_posts;
    const matchDayPct = totalMatchCycle > 0 ? Math.round(mb.match_day_posts / totalMatchCycle * 100) : 0;
    const hangoverPct = totalMatchCycle > 0 ? Math.round(mb.hangover_day_posts / totalMatchCycle * 100) : 0;
    const preMatchPct = totalMatchCycle > 0 ? Math.round(mb.pre_match_posts / totalMatchCycle * 100) : 0;
    const otherPct = Math.max(0, 100 - matchDayPct - hangoverPct - preMatchPct);
    return m("div", {
      className: "UserStats-card UserStats-card--matchBehavior"
    }, m("div", {
      className: "UserStats-cardHeader"
    }, m("i", {
      className: "fas fa-futbol"
    }), m("h3", null, app.translator.trans('nagusi-user-stats.forum.match_behavior.title'))), m("div", {
      className: "UserStats-cardBody"
    }, m("div", {
      className: "UserStats-statSection"
    }, m("div", {
      className: "UserStats-metricRow"
    }, m("div", {
      className: "UserStats-metricItem"
    }, m("span", {
      className: "UserStats-metricNumber"
    }, mb.match_day_posts), m("span", {
      className: "UserStats-metricLabel"
    }, m("i", {
      className: "fas fa-stopwatch text-danger"
    }), " ", app.translator.trans('nagusi-user-stats.forum.match_behavior.match_day')), m("span", {
      className: "UserStats-metricPct"
    }, matchDayPct, "%")), m("div", {
      className: "UserStats-metricItem"
    }, m("span", {
      className: "UserStats-metricNumber"
    }, mb.hangover_day_posts), m("span", {
      className: "UserStats-metricLabel"
    }, m("i", {
      className: "fas fa-coffee text-warning"
    }), " ", app.translator.trans('nagusi-user-stats.forum.match_behavior.hangover_day')), m("span", {
      className: "UserStats-metricPct"
    }, hangoverPct, "%")), m("div", {
      className: "UserStats-metricItem"
    }, m("span", {
      className: "UserStats-metricNumber"
    }, mb.pre_match_posts), m("span", {
      className: "UserStats-metricLabel"
    }, m("i", {
      className: "fas fa-hourglass-start text-info"
    }), " ", app.translator.trans('nagusi-user-stats.forum.match_behavior.pre_match')), m("span", {
      className: "UserStats-metricPct"
    }, preMatchPct, "%")), m("div", {
      className: "UserStats-metricItem"
    }, m("span", {
      className: "UserStats-metricNumber"
    }, mb.other_day_posts), m("span", {
      className: "UserStats-metricLabel"
    }, m("i", {
      className: "fas fa-calendar-alt text-muted"
    }), " ", app.translator.trans('nagusi-user-stats.forum.match_behavior.other_days')), m("span", {
      className: "UserStats-metricPct"
    }, otherPct, "%"))), m("div", {
      className: "UserStats-stackedBar"
    }, m("div", {
      className: "UserStats-barSegment bar-matchDay",
      style: {
        width: "".concat(matchDayPct, "%")
      },
      title: "D\xEDa de partido: ".concat(matchDayPct, "%")
    }), m("div", {
      className: "UserStats-barSegment bar-hangover",
      style: {
        width: "".concat(hangoverPct, "%")
      },
      title: "Resaca: ".concat(hangoverPct, "%")
    }), m("div", {
      className: "UserStats-barSegment bar-preMatch",
      style: {
        width: "".concat(preMatchPct, "%")
      },
      title: "Previa: ".concat(preMatchPct, "%")
    }), m("div", {
      className: "UserStats-barSegment bar-other",
      style: {
        width: "".concat(otherPct, "%")
      },
      title: "D\xEDas corrientes: ".concat(otherPct, "%")
    }))), m("div", {
      className: "UserStats-subGrid"
    }, m("div", {
      className: "UserStats-subBox"
    }, m("span", {
      className: "UserStats-subBoxTitle"
    }, "Presencia seg\xFAn Resultado"), m("div", {
      className: "UserStats-tagList"
    }, m("span", {
      className: "UserStats-badge badge-win",
      title: "Mensajes tras victoria"
    }, m("i", {
      className: "fas fa-smile"
    }), " ", app.translator.trans('nagusi-user-stats.forum.match_behavior.victories'), ": ", m("strong", null, mb.on_victories)), m("span", {
      className: "UserStats-badge badge-loss",
      title: "Mensajes tras derrota"
    }, m("i", {
      className: "fas fa-frown"
    }), " ", app.translator.trans('nagusi-user-stats.forum.match_behavior.defeats'), ": ", m("strong", null, mb.on_defeats)), m("span", {
      className: "UserStats-badge badge-draw",
      title: "Mensajes tras empate"
    }, m("i", {
      className: "fas fa-meh"
    }), " ", app.translator.trans('nagusi-user-stats.forum.match_behavior.draws'), ": ", m("strong", null, mb.on_draws)))), m("div", {
      className: "UserStats-subBox"
    }, m("span", {
      className: "UserStats-subBoxTitle"
    }, "Radar de Emociones & Calenturas"), m("div", {
      className: "UserStats-tagList"
    }, m("span", {
      className: "UserStats-badge badge-referee",
      title: "Protestas o menciones al \xE1rbitro"
    }, m("i", {
      className: "fas fa-bullhorn"
    }), " ", app.translator.trans('nagusi-user-stats.forum.match_behavior.complaints'), ": ", m("strong", null, mb.referee_complaints)), m("span", {
      className: "UserStats-badge badge-criticism",
      title: "Cr\xEDticas de alto impacto"
    }, m("i", {
      className: "fas fa-bolt"
    }), " ", app.translator.trans('nagusi-user-stats.forum.match_behavior.criticism'), ": ", m("strong", null, mb.harsh_criticism)), m("span", {
      className: "UserStats-badge badge-outburst",
      title: "Desahogos viscerales"
    }, m("i", {
      className: "fas fa-fire"
    }), " ", app.translator.trans('nagusi-user-stats.forum.match_behavior.outbursts'), ": ", m("strong", null, mb.passionate_outbursts)))))));
  }
  renderSparringsCard(sparrings) {
    if (!sparrings) return null;
    const renderSparringList = (list, isOutbound) => {
      if (!list || list.length === 0) {
        return m("div", {
          className: "UserStats-emptySub"
        }, app.translator.trans('nagusi-user-stats.forum.sparrings.no_data'));
      }
      const maxCount = Math.max(...list.map(s => s.count), 1);
      return m("div", {
        className: "UserStats-sparringList"
      }, list.map(s => {
        const pct = Math.round(s.count / maxCount * 100);
        return m("div", {
          className: "UserStats-sparringRow",
          key: s.id
        }, m("a", {
          href: app.route('user', {
            username: s.username
          }),
          className: "UserStats-sparringUser"
        }, s.avatar_url ? m("img", {
          src: s.avatar_url,
          alt: s.username,
          className: "UserStats-avatarMini"
        }) : m("span", {
          className: "UserStats-avatarFallback"
        }, s.username.charAt(0).toUpperCase()), m("span", {
          className: "UserStats-sparringName"
        }, s.username)), m("div", {
          className: "UserStats-sparringProgress"
        }, m("div", {
          className: "UserStats-sparringBar ".concat(isOutbound ? 'bar-outbound' : 'bar-inbound'),
          style: {
            width: "".concat(pct, "%")
          }
        })), m("span", {
          className: "UserStats-sparringBadge"
        }, app.translator.trans('nagusi-user-stats.forum.sparrings.replies_count', {
          count: s.count
        })));
      }));
    };
    return m("div", {
      className: "UserStats-card UserStats-card--sparrings"
    }, m("div", {
      className: "UserStats-cardHeader"
    }, m("i", {
      className: "fas fa-comments"
    }), m("h3", null, app.translator.trans('nagusi-user-stats.forum.sparrings.title'))), m("div", {
      className: "UserStats-cardBody"
    }, m("div", {
      className: "UserStats-sparringsSplit"
    }, m("div", {
      className: "UserStats-sparringCol"
    }, m("h4", {
      className: "UserStats-sparringColTitle"
    }, m("i", {
      className: "fas fa-reply text-danger"
    }), " ", app.translator.trans('nagusi-user-stats.forum.sparrings.outbound_title')), renderSparringList(sparrings.outbound, true)), m("div", {
      className: "UserStats-sparringCol"
    }, m("h4", {
      className: "UserStats-sparringColTitle"
    }, m("i", {
      className: "fas fa-quote-left text-success"
    }), " ", app.translator.trans('nagusi-user-stats.forum.sparrings.inbound_title')), renderSparringList(sparrings.inbound, false)))));
  }
  renderRatingsCard(ratings) {
    if (!ratings) return null;
    const hasVotes = ratings.total_votes > 0;
    const favoriteList = ratings.favorite_players || (ratings.favorite_player ? [ratings.favorite_player] : []);
    const criticizedList = ratings.criticized_players || (ratings.criticized_player ? [ratings.criticized_player] : []);
    const renderPlayerItem = (player, index, isFav) => m("div", {
      className: "UserStats-playerRowItem ".concat(index === 0 ? 'is-top' : ''),
      key: player.id
    }, m("span", {
      className: "UserStats-playerRank rank-".concat(index + 1)
    }, "#", index + 1), player.photo_url ? m("img", {
      src: player.photo_url,
      alt: player.name,
      className: "UserStats-playerPhoto"
    }) : m("span", {
      className: "UserStats-playerPhotoFallback"
    }, player.name.charAt(0)), m("div", {
      className: "UserStats-playerDetails"
    }, m("div", {
      className: "UserStats-playerName"
    }, player.name, player.number && m("span", {
      className: "UserStats-playerDorsal"
    }, "#", player.number)), m("div", {
      className: "UserStats-playerAvg"
    }, m("span", {
      className: "rating-pill ".concat(isFav ? 'rating-pill--high' : 'rating-pill--low')
    }, m("i", {
      className: "fas fa-star"
    }), " ", player.avg.toFixed(2)), m("span", {
      className: "votes-count"
    }, "(", player.votes, " votos)"))));
    return m("div", {
      className: "UserStats-card UserStats-card--ratings"
    }, m("div", {
      className: "UserStats-cardHeader"
    }, m("i", {
      className: "fas fa-star-half-alt"
    }), m("h3", null, app.translator.trans('nagusi-user-stats.forum.ratings.title'))), m("div", {
      className: "UserStats-cardBody"
    }, m("div", {
      className: "UserStats-ratingsOverview"
    }, m("div", {
      className: "UserStats-ratingScoreBox"
    }, m("span", {
      className: "UserStats-scoreNumber"
    }, ratings.user_avg !== null ? ratings.user_avg.toFixed(2) : '-'), m("span", {
      className: "UserStats-scoreLabel"
    }, app.translator.trans('nagusi-user-stats.forum.ratings.user_avg'))), m("div", {
      className: "UserStats-ratingCompareDivider"
    }, m("i", {
      className: "fas fa-exchange-alt"
    })), m("div", {
      className: "UserStats-ratingScoreBox"
    }, m("span", {
      className: "UserStats-scoreNumber"
    }, ratings.global_avg !== null ? ratings.global_avg.toFixed(2) : '-'), m("span", {
      className: "UserStats-scoreLabel"
    }, app.translator.trans('nagusi-user-stats.forum.ratings.forum_avg'))), m("div", {
      className: "UserStats-ratingMeta"
    }, m("span", {
      className: "UserStats-metaPill"
    }, m("i", {
      className: "fas fa-check-circle"
    }), " ", app.translator.trans('nagusi-user-stats.forum.ratings.matches_voted', {
      count: ratings.matches_voted
    })), m("span", {
      className: "UserStats-metaPill"
    }, m("i", {
      className: "fas fa-poll"
    }), " ", app.translator.trans('nagusi-user-stats.forum.ratings.total_votes', {
      count: ratings.total_votes
    })))), hasVotes && (favoriteList.length > 0 || criticizedList.length > 0) ? m("div", {
      className: "UserStats-playersSpotlight"
    }, m("div", {
      className: "UserStats-playerSpotlightCard spotlight-fav"
    }, m("div", {
      className: "UserStats-spotlightTag tag-fav"
    }, m("i", {
      className: "fas fa-heart"
    }), " ", app.translator.trans('nagusi-user-stats.forum.ratings.favorite')), m("div", {
      className: "UserStats-playerList"
    }, favoriteList.length > 0 ? favoriteList.map((player, idx) => renderPlayerItem(player, idx, true)) : m("div", {
      className: "UserStats-emptySub"
    }, app.translator.trans('nagusi-user-stats.forum.ratings.no_votes')))), m("div", {
      className: "UserStats-playerSpotlightCard spotlight-crit"
    }, m("div", {
      className: "UserStats-spotlightTag tag-crit"
    }, m("i", {
      className: "fas fa-crosshairs"
    }), " ", app.translator.trans('nagusi-user-stats.forum.ratings.criticized')), m("div", {
      className: "UserStats-playerList"
    }, criticizedList.length > 0 ? criticizedList.map((player, idx) => renderPlayerItem(player, idx, false)) : m("div", {
      className: "UserStats-emptySub"
    }, app.translator.trans('nagusi-user-stats.forum.ratings.no_votes'))))) : m("div", {
      className: "UserStats-emptySub"
    }, app.translator.trans('nagusi-user-stats.forum.ratings.no_votes'))));
  }
  renderHourlyCard(hours, tb) {
    if (!hours || hours.length === 0) return null;
    const maxCount = Math.max(...hours.map(h => h.count), 1);
    const totalDayPosts = ((tb == null ? void 0 : tb.night) || 0) + ((tb == null ? void 0 : tb.morning) || 0) + ((tb == null ? void 0 : tb.afternoon) || 0) + ((tb == null ? void 0 : tb.evening) || 0);
    return m("div", {
      className: "UserStats-card UserStats-card--hourly"
    }, m("div", {
      className: "UserStats-cardHeader"
    }, m("i", {
      className: "fas fa-clock"
    }), m("h3", null, app.translator.trans('nagusi-user-stats.forum.activity_hours.title')), (tb == null ? void 0 : tb.peak_hour) !== undefined && m("span", {
      className: "UserStats-headerBadge"
    }, m("i", {
      className: "fas fa-fire-alt text-danger"
    }), " ", app.translator.trans('nagusi-user-stats.forum.activity_hours.peak_hour', {
      hour: tb.peak_hour
    }))), m("div", {
      className: "UserStats-cardBody"
    }, m("div", {
      className: "UserStats-timeBuckets"
    }, m("div", {
      className: "UserStats-timeBucket"
    }, m("span", {
      className: "UserStats-bucketName"
    }, m("i", {
      className: "fas fa-moon text-indigo"
    }), " ", app.translator.trans('nagusi-user-stats.forum.activity_hours.night')), m("span", {
      className: "UserStats-bucketValue"
    }, (tb == null ? void 0 : tb.night) || 0)), m("div", {
      className: "UserStats-timeBucket"
    }, m("span", {
      className: "UserStats-bucketName"
    }, m("i", {
      className: "fas fa-sun text-warning"
    }), " ", app.translator.trans('nagusi-user-stats.forum.activity_hours.morning')), m("span", {
      className: "UserStats-bucketValue"
    }, (tb == null ? void 0 : tb.morning) || 0)), m("div", {
      className: "UserStats-timeBucket"
    }, m("span", {
      className: "UserStats-bucketName"
    }, m("i", {
      className: "fas fa-cloud-sun text-primary"
    }), " ", app.translator.trans('nagusi-user-stats.forum.activity_hours.afternoon')), m("span", {
      className: "UserStats-bucketValue"
    }, (tb == null ? void 0 : tb.afternoon) || 0)), m("div", {
      className: "UserStats-timeBucket"
    }, m("span", {
      className: "UserStats-bucketName"
    }, m("i", {
      className: "fas fa-star text-info"
    }), " ", app.translator.trans('nagusi-user-stats.forum.activity_hours.evening')), m("span", {
      className: "UserStats-bucketValue"
    }, (tb == null ? void 0 : tb.evening) || 0))), m("div", {
      className: "UserStats-hourlyChart"
    }, hours.map(item => {
      const heightPct = Math.max(Math.round(item.count / maxCount * 100), 4);
      const isPeak = item.hour === (tb == null ? void 0 : tb.peak_hour);
      return m("div", {
        className: "UserStats-chartCol ".concat(isPeak ? 'col-peak' : ''),
        key: item.hour
      }, m("div", {
        className: "UserStats-chartBarWrap",
        title: "".concat(item.hour, ":00h - ").concat(item.count, " mensajes")
      }, m("div", {
        className: "UserStats-chartBar",
        style: {
          height: "".concat(heightPct, "%")
        }
      })), m("span", {
        className: "UserStats-chartLabel"
      }, item.hour % 3 === 0 ? "".concat(item.hour, "h") : ''));
    }))));
  }
  renderLexiconCard(lex) {
    if (!lex) return null;
    return m("div", {
      className: "UserStats-card UserStats-card--lexicon"
    }, m("div", {
      className: "UserStats-cardHeader"
    }, m("i", {
      className: "fas fa-icons"
    }), m("h3", null, app.translator.trans('nagusi-user-stats.forum.lexicon_and_emojis.title'))), m("div", {
      className: "UserStats-cardBody"
    }, m("div", {
      className: "UserStats-lexiconTop"
    }, m("div", {
      className: "UserStats-lexiconMetric"
    }, m("span", {
      className: "UserStats-lexiconNum"
    }, lex.avg_words_per_post), m("span", {
      className: "UserStats-lexiconLabel"
    }, app.translator.trans('nagusi-user-stats.forum.lexicon_and_emojis.avg_words'))), m("div", {
      className: "UserStats-lexiconMetric"
    }, m("span", {
      className: "UserStats-lexiconNum"
    }, lex.total_custom_emojis_used), m("span", {
      className: "UserStats-lexiconLabel"
    }, app.translator.trans('nagusi-user-stats.forum.lexicon_and_emojis.total_emojis'))), m("div", {
      className: "UserStats-lexiconMetric"
    }, m("span", {
      className: "UserStats-lexiconNum"
    }, lex.total_reactions_given || 0), m("span", {
      className: "UserStats-lexiconLabel"
    }, app.translator.trans('nagusi-user-stats.forum.lexicon_and_emojis.total_reactions')))), m("div", {
      className: "UserStats-lexiconVisuals"
    }, m("div", {
      className: "UserStats-emojisShowcase"
    }, m("div", {
      className: "UserStats-emojisTitle"
    }, m("i", {
      className: "fas fa-laugh-beam text-warning"
    }), " ", app.translator.trans('nagusi-user-stats.forum.lexicon_and_emojis.top_emojis'), ":"), lex.top_emojis && lex.top_emojis.length > 0 ? m("div", {
      className: "UserStats-emojisList"
    }, lex.top_emojis.map(e => m("div", {
      className: "UserStats-emojiItem",
      key: e.name,
      title: "".concat(e.name, " (").concat(e.count, " veces)")
    }, m("img", {
      src: e.url,
      alt: e.name,
      className: "UserStats-emojiImg"
    }), m("span", {
      className: "UserStats-emojiBadge"
    }, e.count)))) : m("div", {
      className: "UserStats-emptySub"
    }, app.translator.trans('nagusi-user-stats.forum.lexicon_and_emojis.no_emojis'))), m("div", {
      className: "UserStats-emojisShowcase"
    }, m("div", {
      className: "UserStats-emojisTitle"
    }, m("i", {
      className: "fas fa-heart text-danger"
    }), " ", app.translator.trans('nagusi-user-stats.forum.lexicon_and_emojis.top_reactions'), ":"), lex.top_reactions && lex.top_reactions.length > 0 ? m("div", {
      className: "UserStats-emojisList"
    }, lex.top_reactions.map(r => m("div", {
      className: "UserStats-emojiItem UserStats-emojiItem--reaction",
      key: r.identifier,
      title: "".concat(r.identifier, " (").concat(r.count, " veces)")
    }, r.url ? m("img", {
      src: r.url,
      alt: r.identifier,
      className: "UserStats-emojiImg UserStats-emojiImg--reaction"
    }) : m("span", {
      className: "UserStats-reactionFallback"
    }, r.identifier), m("span", {
      className: "UserStats-emojiBadge"
    }, r.count)))) : m("div", {
      className: "UserStats-emptySub"
    }, app.translator.trans('nagusi-user-stats.forum.lexicon_and_emojis.no_reactions'))))));
  }
  renderPollsCard(polls) {
    if (!polls) return null;
    const participationPct = Math.min(Math.round(polls.participation_rate || 0), 100);
    return m("div", {
      className: "UserStats-card UserStats-card--polls"
    }, m("div", {
      className: "UserStats-cardHeader"
    }, m("i", {
      className: "fas fa-poll-h"
    }), m("h3", null, app.translator.trans('nagusi-user-stats.forum.polls.title')), m("span", {
      className: "UserStats-headerBadge"
    }, m("i", {
      className: "fas fa-chart-pie text-primary"
    }), " ", app.translator.trans('nagusi-user-stats.forum.polls.participation_rate', {
      rate: polls.participation_rate
    }))), m("div", {
      className: "UserStats-cardBody"
    }, m("div", {
      className: "UserStats-pollsMetrics"
    }, m("div", {
      className: "UserStats-pollMetricBox"
    }, m("span", {
      className: "UserStats-pollMetricNum text-warning"
    }, polls.polls_created), m("span", {
      className: "UserStats-pollMetricLabel"
    }, m("i", {
      className: "fas fa-plus-circle"
    }), " ", app.translator.trans('nagusi-user-stats.forum.polls.created'))), m("div", {
      className: "UserStats-pollMetricBox"
    }, m("span", {
      className: "UserStats-pollMetricNum text-success"
    }, polls.polls_voted), m("span", {
      className: "UserStats-pollMetricLabel"
    }, m("i", {
      className: "fas fa-vote-yea"
    }), " ", app.translator.trans('nagusi-user-stats.forum.polls.voted'))), m("div", {
      className: "UserStats-pollMetricBox"
    }, m("span", {
      className: "UserStats-pollMetricNum text-muted"
    }, polls.total_polls), m("span", {
      className: "UserStats-pollMetricLabel"
    }, m("i", {
      className: "fas fa-archive"
    }), " ", app.translator.trans('nagusi-user-stats.forum.polls.total')))), m("div", {
      className: "UserStats-pollProgressSection"
    }, m("div", {
      className: "UserStats-pollProgressHeader"
    }, m("span", {
      className: "UserStats-pollProgressTitle"
    }, m("i", {
      className: "fas fa-tasks"
    }), " ", app.translator.trans('nagusi-user-stats.forum.polls.participation')), m("span", {
      className: "UserStats-pollProgressValue"
    }, m("strong", null, polls.polls_voted), " / ", polls.total_polls, " (", participationPct, "%)")), m("div", {
      className: "UserStats-pollProgressBar"
    }, m("div", {
      className: "UserStats-pollProgressFill",
      style: {
        width: "".concat(participationPct, "%")
      },
      title: "".concat(participationPct, "%")
    })))));
  }
  renderKarmaCard(karma) {
    if (!karma) return null;

    // Generosity badge classification
    let generosityClass = 'badge-neutral';
    let generosityText = 'Equilibrado';
    if (karma.generosity_ratio >= 1.2) {
      generosityClass = 'badge-generous';
      generosityText = 'Muy Generoso (Repartidor)';
    } else if (karma.generosity_ratio < 0.4) {
      generosityClass = 'badge-stingy';
      generosityText = 'Tacaño (Exclusivo)';
    }
    return m("div", {
      className: "UserStats-card UserStats-card--karma"
    }, m("div", {
      className: "UserStats-cardHeader"
    }, m("i", {
      className: "fas fa-heart"
    }), m("h3", null, app.translator.trans('nagusi-user-stats.forum.karma.title'))), m("div", {
      className: "UserStats-cardBody"
    }, m("div", {
      className: "UserStats-karmaOverview"
    }, m("div", {
      className: "UserStats-karmaItem"
    }, m("span", {
      className: "UserStats-karmaNum text-success"
    }, karma.likes_given), m("span", {
      className: "UserStats-karmaLabel"
    }, m("i", {
      className: "fas fa-hand-holding-heart"
    }), " ", app.translator.trans('nagusi-user-stats.forum.karma.likes_given'))), m("div", {
      className: "UserStats-karmaItem"
    }, m("span", {
      className: "UserStats-karmaNum text-danger"
    }, karma.likes_received), m("span", {
      className: "UserStats-karmaLabel"
    }, m("i", {
      className: "fas fa-heart"
    }), " ", app.translator.trans('nagusi-user-stats.forum.karma.likes_received'))), m("div", {
      className: "UserStats-karmaItem"
    }, m("span", {
      className: "UserStats-karmaNum text-primary"
    }, karma.generosity_ratio), m("span", {
      className: "UserStats-generosityTag ".concat(generosityClass)
    }, generosityText)), m("div", {
      className: "UserStats-karmaItem"
    }, m("span", {
      className: "UserStats-karmaNum text-info"
    }, karma.likes_per_post), m("span", {
      className: "UserStats-karmaLabel"
    }, app.translator.trans('nagusi-user-stats.forum.karma.likes_per_post')))), karma.most_liked_post ? m("div", {
      className: "UserStats-mostLikedWrap"
    }, m("div", {
      className: "UserStats-mostLikedHeader"
    }, m("i", {
      className: "fas fa-crown text-warning"
    }), " ", app.translator.trans('nagusi-user-stats.forum.karma.most_liked'), m("span", {
      className: "UserStats-likedBadge"
    }, m("i", {
      className: "fas fa-heart"
    }), " ", karma.most_liked_post.likes_count, " likes")), m("a", {
      href: app.route('discussion', {
        id: karma.most_liked_post.discussion_id
      }),
      className: "UserStats-mostLikedDiscussion"
    }, m("i", {
      className: "fas fa-comment-alt"
    }), " ", karma.most_liked_post.discussion_title), m("p", {
      className: "UserStats-mostLikedSnippet"
    }, "\"", karma.most_liked_post.snippet, "\"")) : m("div", {
      className: "UserStats-emptySub"
    }, app.translator.trans('nagusi-user-stats.forum.karma.no_likes'))));
  }
  renderJokoakCard(jokoak) {
    if (!jokoak) return null;
    const hasAldeanos = jokoak.aldeanos && jokoak.aldeanos.matches > 0;
    const hasBolilla = jokoak.bolilla && jokoak.bolilla.matches > 0;
    if (!hasAldeanos && !hasBolilla) return null;
    return m("div", {
      className: "UserStats-card UserStats-card--jokoak"
    }, m("div", {
      className: "UserStats-cardHeader"
    }, m("i", {
      className: "fas fa-gamepad"
    }), m("h3", null, app.translator.trans('nagusi-user-stats.forum.jokoak.title'))), m("div", {
      className: "UserStats-cardBody"
    }, m("div", {
      className: "UserStats-jokoakSplit"
    }, hasAldeanos && m("div", {
      className: "UserStats-jokoakItem"
    }, m("div", {
      className: "UserStats-jokoakTitle"
    }, m("i", {
      className: "fas fa-users-cog text-danger"
    }), " ", app.translator.trans('nagusi-user-stats.forum.jokoak.aldeanos')), m("div", {
      className: "UserStats-jokoakNumbers"
    }, m("span", {
      className: "UserStats-jokoakPoints"
    }, jokoak.aldeanos.points, " ", m("small", null, "pts")), m("div", {
      className: "UserStats-jokoakMeta"
    }, m("span", null, app.translator.trans('nagusi-user-stats.forum.jokoak.matches', {
      matches: jokoak.aldeanos.matches
    })), m("span", null, "\u2022"), m("span", null, app.translator.trans('nagusi-user-stats.forum.jokoak.avg', {
      avg: jokoak.aldeanos.avg
    }))))), hasBolilla && m("div", {
      className: "UserStats-jokoakItem"
    }, m("div", {
      className: "UserStats-jokoakTitle"
    }, m("i", {
      className: "fas fa-futbol text-primary"
    }), " ", app.translator.trans('nagusi-user-stats.forum.jokoak.bolilla')), m("div", {
      className: "UserStats-jokoakNumbers"
    }, m("span", {
      className: "UserStats-jokoakPoints"
    }, jokoak.bolilla.points, " ", m("small", null, "pts")), m("div", {
      className: "UserStats-jokoakMeta"
    }, m("span", null, app.translator.trans('nagusi-user-stats.forum.jokoak.matches', {
      matches: jokoak.bolilla.matches
    })), m("span", null, "\u2022"), m("span", null, app.translator.trans('nagusi-user-stats.forum.jokoak.avg', {
      avg: jokoak.bolilla.avg
    }))))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/user-stats/UserStatsPage', UserStatsPage);